import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PRODUCTS, SLOGANS, CARD_VARIANTS } from '../data/products';
import { useReveal } from '../hooks/useReveal';
import './Home.css';

/* ═══════════════════════════════════════════
   HERO SECTION
═══════════════════════════════════════════ */



/* ═══════════════════════════════════════════
   PRODUCT CARD
═══════════════════════════════════════════ */
function ProductCard({ product, index, variant }) {
  const navigate = useNavigate();
  return (
    <div
      className={`prod-card ${variant} reveal`}
      style={{ animationDelay: `${(index % 4) * 0.07}s` }}
      onClick={() => navigate(`/product/${product.id}`)}
    >
      <div className="card-bar" />
      <span className="card-idx">{String(index + 1).padStart(2, '0')}</span>
      <span className="card-emoji">{product.emoji}</span>
      <h3 className="card-name">{product.name}</h3>
      <ul className="card-feats">
        {product.points.map((pt, i) => (
          <li key={i} className="card-feat">
            <span className="feat-bullet" />
            {pt}
          </li>
        ))}
      </ul>
      <button className="card-btn">View Details →</button>
    </div>
  );
}

/* ═══════════════════════════════════════════
   PRODUCTS SECTION
═══════════════════════════════════════════ */
function ProductsSection() {
  const gridRef = useReveal();

  return (
    <section id="products" className="products-section products-page-section">
       <img src="/banner.jpg" alt="banner" className="hero-bg" />
      <div className="sec-head">
        <div className="reveal sec-eyebrow">Our AI Product Suite</div>
        <h2 className="reveal sec-title">
          Transforming Industries with <em>Intelligence</em>
        </h2>
        <p className="reveal sec-sub">
          Explore our AI-powered solutions built for education, healthcare, finance, real estate, and more.
        </p>
      </div>

      <div className="prod-grid container" ref={gridRef}>
        {PRODUCTS.map((product, i) => (
          <ProductCard
            key={product.id}
            product={product}
            index={i}
            variant={CARD_VARIANTS[i % CARD_VARIANTS.length]}
          />
        ))}
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════
   Products PAGE
═══════════════════════════════════════════ */
export default function Products() {
  // Check hash on mount
  useEffect(() => {
    if (window.location.hash === '#products') {
      setTimeout(() => {
        document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, []);

  return (
    <>
      <ProductsSection />
    </>
  );
}
